<template>
	<div class='knd-rope' >
    <div class="line-controller">
      
      <svg class='svg' preserveAspectRatio="none" style="fill:none"  viewBox="0 0 267 1084" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- <path id="path-line2-1"  d="M126.998 1C135.697 5.64646 212 228.5 111.5 228.5C11 228.5 187.026 548.058 162.999 547.5" /> -->
        <!-- <path  id="path-line2-1" d="M29.497 -9.43814e-06C29.497 28 -45.318 83.2702 47.4971 113C111.497 133.5 122.088 125.5 135.997 176.5C144.997 209.5 110.497 236.5 83.9971 224C57.4971 211.5 31.9972 222 31.9972 556.5" /> -->
        <!-- <path id="path-line2-1" d="M108.96 244.5C108.96 216.5 183.775 161.23 90.9596 131.5C26.9596 111 16.3686 119 2.45955 68C-6.54044 35 27.9595 8 54.4595 20.5C80.9596 33 106.459 22.5 106.459 0" /> -->
        <!-- <path id="path-line2-1" d="M108.96 0C108.96 28 183.775 83.2702 90.9596 113C26.9596 133.5 16.3686 125.5 2.45955 176.5C-6.54044 209.5 27.9595 236.5 54.4595 224C80.9596 211.5 106.459 222 126.459 556.5" stroke="url(#paint0_linear_254_86)"/> -->
        <path id="path-line2-1" d="M134 0C134 20.7134 162.289 112.823 110.609 112.823C52.1814 112.823 -13.422 155.976 14.461 309.145C42.344 462.314 169.5 431.266 197.143 359.187C209.882 323.147 205.315 277.149 186.566 283.314C168.943 289.109 172.865 341.167 210.603 320.302C248.342 299.437 275.263 370.568 263.004 408.979C250.745 447.389 124.551 440.751 151.713 520.417C178.875 600.084 220.939 532.497 210.603 588.928C192.93 685.423 85 412.295 47.5 498.107C19.9819 561.078 38.0173 605.525 50.5166 626.39C63.0159 647.255 89.697 626.39 77.6785 588.928C61.0697 537.157 27.6814 611.689 50.5166 688.985C77.2331 779.419 188.008 770.075 173.586 855.432C162.336 922.013 1 737.065 1 855.432C1 958.335 119.743 896.214 119.743 1084" stroke="url(#paint0_linear_280_83)"/>

        <defs>
          <linearGradient id="Gradient2" x1="1.5" y1="1" x2="1.49998" y2="555" gradientUnits="userSpaceOnUse">
          <stop stop-color="#28006D"/>
          <stop offset="0.0833333" stop-color="#4D00FF"/>
          <stop offset="0.197917" stop-color="white"/>
          <stop offset="0.703125" stop-color="white"/>
          <stop offset="1" stop-color="#6A706D"/>
          </linearGradient>

     
            <linearGradient id="paint1_linear_0_1" x1="162.49" y1="167.101" x2="155.49" y2="201.101" gradientUnits="userSpaceOnUse">
            <stop stop-color="#575757"/>
            <stop offset="0.5" stop-color="white"/>
            <stop offset="1" stop-color="#6A706D"/>
            </linearGradient>

        </defs>
        </svg>
    </div>
	</div>
</template>

<script>

import { useStore } from 'vuex';
import { ref, onMounted } from 'vue';
import scrollSvg from 'scroll-svg'

export default {
  setup () {
    const store = useStore();
    const table = ref(null);
    const observer = ref({});
    const scrollRef = ref();
    
    let path;

    onMounted(() => {
      path = document.querySelector('#path-line2-1');
      const svg = scrollSvg(path, { speed: 1.1});
    });

    return {
      data: store.getters.data,
      scrollRef
    }
  }
}
</script>

<style lang="scss">
.knd-rope {
  height: 100%;
  width: 100%;
  position:absolute;
  pointer-events: none;
  z-index: 0;
}
  .line-controller {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    // height: 100%;
    text-align: center;
    overflow: hidden;

    svg {
      display: inline-block;
      height: 100%;
      width: 100%;

      .arrow {
        // visibility: hidden;
        display: inline-block;
      }

      path {
        stroke: url(#Gradient2);
        stroke-width: .5;
      }
    }
  }


</style>
